import { Link } from 'react-router'

import { Button } from 'components'
import { Enum, TemplateUtils } from 'utils'

import './showcaseTemplates.scss'

const primaryPages = ['Product', 'Collection', 'Article']
const secondaryPages = ['Page', 'Catalog', 'Search', 'Blog', '404']

export default class ShowcaseTemplates extends React.Component {
  static propTypes = {
    nextRouteA: React.PropTypes.string.isRequired,
    nextRouteB: React.PropTypes.string.isRequired,
  }

  state = {
    showMore: false,
  }

  renderFormulaItem(item) {
    const key = `formula-${item.key}`

    if (item.fixed) {
      const text = item.separator ? item.template : item.text

      return (
        <div className={`showcaseTemplates__formula__item fixed ${item.static ? 'static' : ''}`} key={key}>
          {text}
        </div>
      )
    }

    return null
  }

  renderFormula(formula) {
    return (
      <div className="showcaseTemplates__formula">
        {formula.map(item => this.renderFormulaItem(item))}
      </div>
    )
  }

  renderTemplate(resourceName) {
    return (
      <div key={`page-${resourceName}`} className="showcaseTemplates__page large-spacing--bottom">
        <div className="showcaseTemplates__page__headline">
          <h4>{resourceName}</h4>
        </div>
        <div className="showcaseTemplates__page__content">
          <div className="showcaseTemplates__page__title">
            {this.renderFormula(Enum.TitleTemplateFormula[resourceName])}
          </div>
          <div className="showcaseTemplates__page__description">
            {this.renderFormula(Enum.DescriptionTemplateFormula[resourceName])}
          </div>
        </div>
      </div>
    )
  }

  renderPrimaryTemplates() {
    return (
      <div className="showcaseTemplates__primaryPages">
        {primaryPages.map(page => this.renderTemplate(page))}
      </div>
    )
  }

  renderSecondaryTemplates() {
    if (!this.state.showMore) return null

    return (
      <div className="showcaseTemplates__secondaryPages">
        {secondaryPages.map(page => this.renderTemplate(page))}
      </div>
    )
  }

  render() {
    const { showMore } = this.state

    return (
      <div className="showcaseTemplates">
        <div className="showcaseTemplates__title large-spacing--bottom">
          <h2 className="small-spacing--bottom">Recommended SEO-friendly Templates</h2>
          <p className="body2">Plug in SEO provides a proven set of SEO-friendly templates for your page titles and meta descriptions</p>
        </div>
        {this.renderPrimaryTemplates()}
        {this.renderSecondaryTemplates()}
        <a
          className="show-more"
          onClick={() => this.setState({ showMore: !showMore })}
        >Show {showMore ? 'less' : 'more'}</a>
        <div className="showcaseTemplates__actions xlarge-spacing--top">
          <Link to={this.props.nextRouteA}>
            <Button
              label="Install and Apply"
              buttonType="primary"
            />
          </Link>
          <Link to={this.props.nextRouteB} className="small-spacing--left">
            <Button
              label="Skip for now"
              buttonType="secondary"
            />
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/onboarding/ShowcaseTemplates.js